import { apiResourceUrl } from "@ploy-lib/core";
import { v4 as uuidv4 } from "uuid";
import { BaseCamelCasedResource } from "./BaseResource";
class BeneficialOwnerResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.id = null;
        this.__id = this.id ?? uuidv4();
    }
    pk() {
        return `${this.id || this.__id}`;
    }
    static url(urlParams) {
        if (urlParams) {
            let body = urlParams.customerId ? `customerId=${urlParams.customerId}&` : '';
            body += urlParams.saveApplication ? `saveApplication=${urlParams.saveApplication}` : '';
            if (this.pk(urlParams) !== undefined) {
                if (this.urlRoot.endsWith("/")) {
                    return `${this.urlRoot}${urlParams.epId}/${this.pk(urlParams)}?${body}`;
                }
                return `${this.urlRoot}/${urlParams.epId}/${this.pk(urlParams)}?${body}`;
            }
        }
        return this.urlRoot;
    }
    static listUrl(searchParams) {
        if (searchParams && Object.keys(searchParams).length) {
            const { epId, ...realSearchParams } = searchParams;
            const params = new URLSearchParams(realSearchParams);
            params.sort();
            if (this.urlRoot.endsWith("/")) {
                return `${this.urlRoot}${epId}?${params.toString()}`;
            }
            return `${this.urlRoot}/${epId}?${params.toString()}`;
        }
        return this.urlRoot;
    }
    static fromCreditService() {
        const endpoint = this.list();
        return endpoint.extend({
            url: (params) => this.listUrl(params).replace(this.urlRoot, `${this.urlRoot}/fromCreditService`),
            method: "post"
        });
    }
    static noBeneficialOwners() {
        const endpoint = this.list();
        return endpoint.extend({
            url: (params) => this.listUrl(params).replace(this.urlRoot, `${this.urlRoot}/noBeneficialOwners`),
            method: "post"
        });
    }
}
BeneficialOwnerResource.urlRoot = apiResourceUrl("BeneficialOwner");
export { BeneficialOwnerResource };
//# sourceMappingURL=BeneficialOwnerResource.js.map